import React from 'react';

// eslint-disable-next-line react/prop-types
const Exclamation = ({ fill = '' }) => (
  <svg
    width="22px"
    height="22px"
    viewBox="0 0 22 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>4EC4D0BC-4CC0-4872-A86A-DB61FFA85C6E</title>
    <desc>Created with sketchtool.</desc>
    <g
      id="Final-design--(Web)"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Upload-documents-final"
        transform="translate(-253.000000, -252.000000)"
      >
        <g id="Group" transform="translate(254.000000, 253.000000)">
          <path
            d="M0.918887853,7.77627146 L7.77627146,0.918887853 C9.00145526,-0.306295951 10.9879749,-0.306295951 12.2131587,0.918887853 L19.0705423,7.77627146 C20.2957261,9.00145526 20.2957261,10.9879749 19.0705423,12.2131587 L12.2131587,19.0705423 C10.9879749,20.2957261 9.00145526,20.2957261 7.77627146,19.0705423 L0.918887853,12.2131587 C-0.306295951,10.9879749 -0.306295951,9.00145526 0.918887853,7.77627146 Z"
            id="Path"
            stroke={fill || '#F7B500'}
            strokeWidth="1.5"
            fillRule="nonzero"
          />
          <path
            d="M10.3,4 C10.8522461,4 11.3,4.36634408 11.3,4.81818182 L11.3,11.3636364 C11.3,11.8154741 10.8522461,12.1818182 10.3,12.1818182 C9.74775387,12.1818182 9.3,11.8154741 9.3,11.3636364 L9.3,4.81818182 C9.3,4.36634408 9.74775387,4 10.3,4 Z"
            id="Path"
            fill={fill || '#F7B500'}
            fillRule="nonzero"
          />
          <circle
            id="Oval"
            fill={fill || '#F7B500'}
            cx="10.25"
            cy="14.25"
            r="1.25"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default Exclamation;
